import React, { Component } from 'react';
import { Col } from "react-bootstrap";
import { Bar } from "react-chartjs-2";
import Button from "@material-ui/core/Button";
import { addDataOnBar } from '../modules/helpers';

const printFrequencySet = {
    labels: [],
    datasets: [
        {
            label: 'printer',
            backgroundColor: 'rgba(75,192,192,1)',
            data: []
        }
    ]
};

const printFrequencyIntervals = ["day", "week", "month"];
const defaultStatisticsInterval = 'day';

export default class PrintDataPrintFrequency extends Component {
    constructor(props) {
        super(props);
        this.state = {
            statisticsInterval: defaultStatisticsInterval,
            printFrequencySet
        }
    }

    resolvePrintFrequencySet = (statisticsInterval) => {
        const printFrequencyData = this.props.printFrequenciesData[statisticsInterval];
        const printTimesSetLabels = [];
        const printTimesSetData = [];
        for (let [key, value] of Object.entries(printFrequencyData)) {
            printTimesSetLabels.push(key);
            printTimesSetData.push(value);
        }
        printFrequencySet.labels = printTimesSetLabels;
        printFrequencySet.datasets[0].data = printTimesSetData;
    };

    handlePrintFrequencySelect = (statisticsInterval) => {
        this.resolvePrintFrequencySet(statisticsInterval);
        this.setState({ printFrequencySet, statisticsInterval })
    };

    render() {
        const { statisticsInterval } = this.state;
        this.resolvePrintFrequencySet(statisticsInterval);
        return (
            <Col lg={6} md={6} xs={12}>
                {printFrequencyIntervals.map((item) => {
                    return (<Button key={item}
                                    variant={item === statisticsInterval ? 'outlined' : 'text'}
                                    onClick={(ev) => {
                                        this.handlePrintFrequencySelect(item)
                                    }}>{item}</Button>)
                })}
                <Bar
                    data={printFrequencySet}
                    options={{
                        title: {
                            display: true,
                            text: 'Print Frequency',
                            fontSize: 20
                        },
                        hover: {
                            animationDuration: 0
                        },
                        animation: {
                            onComplete: (chart) => {
                                addDataOnBar(chart)
                            }
                        }
                    }}
                />
            </Col>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/print-data-print-frequency.js